/* DARMA colorway switch — category pages build (Sept 2026).
   Loaded by sections/darma-colorway-switch.liquid (defer, self-guarded). Progressive:
   the server renders the Onyx state; this file only re-points what the sections
   already emitted. No dependencies, no money math, no fetches.

   What a switch to <key> (onyx | terra | abyss | cypress) does:
   - [data-cs-chip]            is-on + aria-pressed follow the key
   - [data-cg-card]            img[data-cg-img] src/srcset ← data-img-<key> / data-imgset-<key>;
                               img[data-cg-img2] ← data-img2-<key> (hover image, hidden when absent);
                               the card href's ?variant= ← data-variant-<key>;
                               [data-dot] is-on follows the key
   - [data-cs-hero]            <source> srcset ← data-hero-desktop-<key>, <img> src ← data-hero-mobile-<key>
   - [data-cs-cta-template]    textContent = template with {COLORWAY} → the chip's name
   - [data-cs-shown-template]  same ("Shown in Onyx")
   - [data-cs-set]             is-on where the attribute equals the key (the set object)
   - [data-cs-pic]             a <picture> (or a span wrapping one): <source> srcset ←
                               data-pic-dset-<key> / data-pic-d-<key>, <img> src/srcset ←
                               data-pic-m-<key> / data-pic-mset-<key>, alt ← data-pic-alt-<key>.
                               A key with no frame of its own falls back to -default, so the
                               on-model editorial tiles and the editorial band follow the
                               switch wherever the photography exists and hold the default
                               frame where it does not (Derek, Sep 21 2026).
   - <html data-colorway>      for CSS hooks
   - URL                       ?colorway=<key> via history.replaceState (no reload)
   On load: ?colorway= is honoured when valid; anything else stays Onyx. */

(function () {
  'use strict';

  if (window.__darmaColorwaySwitch) return;
  window.__darmaColorwaySwitch = true;

  var KEYS = ['onyx', 'terra', 'abyss', 'cypress'];
  var current = 'onyx';

  function each(sel, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }

  function nameOf(key) {
    var chip = document.querySelector('[data-cs-chip="' + key + '"]');
    var n = chip && chip.getAttribute('data-cs-name');
    return n || key.charAt(0).toUpperCase() + key.slice(1);
  }

  function withVariant(href, id) {
    if (!href) return href;
    if (/([?&])variant=\d+/.test(href)) return href.replace(/([?&])variant=\d+/, '$1variant=' + id);
    var hash = '';
    var i = href.indexOf('#');
    if (i !== -1) { hash = href.slice(i); href = href.slice(0, i); }
    return href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + id + hash;
  }

  function swapImg(img, src, set) {
    if (!img || !src) return false;
    if (set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
    img.setAttribute('src', src);
    return true;
  }

  function apply(key, writeUrl) {
    if (KEYS.indexOf(key) === -1) return;
    current = key;
    var name = nameOf(key);

    each('[data-cs-chip]', function (c) {
      var on = c.getAttribute('data-cs-chip') === key;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    each('[data-cg-card]', function (card) {
      var src = card.getAttribute('data-img-' + key);
      if (src) {
        swapImg(card.querySelector('[data-cg-img]'), src, card.getAttribute('data-imgset-' + key));
        var img2 = card.querySelector('[data-cg-img2]');
        if (img2) {
          var src2 = card.getAttribute('data-img2-' + key);
          if (src2) {
            swapImg(img2, src2, card.getAttribute('data-img2set-' + key));
            img2.hidden = false;
            card.classList.add('darma-cg__card--has-hover');
          } else {
            img2.hidden = true;
            card.classList.remove('darma-cg__card--has-hover');
          }
        }
      }
      var vid = card.getAttribute('data-variant-' + key);
      if (vid && card.hasAttribute('href')) card.setAttribute('href', withVariant(card.getAttribute('href'), vid));
      each('[data-dot]', function (d) { d.classList.toggle('is-on', d.getAttribute('data-dot') === key); }, card);
      var cw = card.querySelector('[data-cg-colorway]');
      if (cw && vid) cw.textContent = name;
    });

    each('[data-cs-hero]', function (h) {
      var d = h.getAttribute('data-hero-desktop-' + key);
      var m = h.getAttribute('data-hero-mobile-' + key) || d;
      if (!d) return;
      var source = h.querySelector('source');
      var img = h.querySelector('img');
      if (source) source.setAttribute('srcset', d);
      if (img) { img.removeAttribute('srcset'); img.setAttribute('src', m); }
    });

    each('[data-cs-cta-template]', function (el) {
      el.textContent = el.getAttribute('data-cs-cta-template').replace('{COLORWAY}', name);
    });

    each('[data-cs-shown-template]', function (el) {
      el.textContent = el.getAttribute('data-cs-shown-template').replace('{COLORWAY}', name);
    });

    each('[data-cs-set]', function (s) {
      s.classList.toggle('is-on', s.getAttribute('data-cs-set') === key);
    });

    each('[data-cs-pic]', function (p) {
      var k = p.hasAttribute('data-pic-d-' + key) ? key : 'default';
      var d = p.getAttribute('data-pic-d-' + k);
      if (!d) return;
      var dset = p.getAttribute('data-pic-dset-' + k);
      var m = p.getAttribute('data-pic-m-' + k) || d;
      var mset = p.getAttribute('data-pic-mset-' + k);
      var alt = p.getAttribute('data-pic-alt-' + k);
      var source = p.querySelector('source');
      var img = p.querySelector('img');
      if (source) source.setAttribute('srcset', dset || d);
      if (img) {
        swapImg(img, m, mset);
        if (alt !== null) img.setAttribute('alt', alt);
      }
    });

    document.documentElement.setAttribute('data-colorway', key);

    if (writeUrl && window.history && typeof history.replaceState === 'function') {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('colorway', key);
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) { /* older browsers: the state still switched */ }
    }
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cs-chip]');
    if (!chip) return;
    e.preventDefault();
    apply(chip.getAttribute('data-cs-chip'), true);
  });

  function init() {
    var key = 'onyx';
    try {
      var q = new URLSearchParams(window.location.search).get('colorway');
      if (q) key = String(q).toLowerCase();
    } catch (e) { /* no URLSearchParams: Onyx */ }
    if (KEYS.indexOf(key) === -1) key = 'onyx';
    apply(key, false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* theme editor re-renders a section: re-apply the current state to the new DOM */
  document.addEventListener('shopify:section:load', function () { apply(current, false); });
})();
